import { useTranslation } from 'react-i18next';
import type { ILayoutCardProps } from './ILayoutCardProps';
import { layoutLimits } from './layoutDefaults';
import { LayoutNumber } from './LayoutNumber';

/** Картка «Сітка» (прототип v4): одиниця поля (110–240 пкс), дві колонки груп від (360–720 пкс), довгий варіант вибору (символів). */
export function LayoutGridCard({ layout, canEdit, onSave }: ILayoutCardProps) {
  const { t } = useTranslation();
  const num = (key: 'unit' | 'groupMin' | 'longOption', hint: string) => (
    <LayoutNumber label={t(`sysCust.layout.${key}`)} hint={hint} value={layout[key]} min={layoutLimits[key][0]} max={layoutLimits[key][1]} disabled={!canEdit}
      onCommit={(v) => onSave({ ...layout, [key]: v })} />
  );
  return (
    <section className="cu-panel" aria-label={t('sysCust.layout.grid')}>
      <div className="cu-titles"><div className="sp-eyebrow">{t('sysCust.layout.grid')}</div><div className="sp-muted">{t('sysCust.layout.gridDesc')}</div></div>
      <div className="cu-nums">
        {num('unit', t('sysCust.layout.unitHint'))}
        {num('groupMin', t('sysCust.layout.groupMinHint'))}
        {num('longOption', t('sysCust.layout.chars'))}
      </div>
    </section>
  );
}
